import jwtDecode from 'jwt-decode';

import { GoogleUnableToAuthenticateUserError } from '../Errors';

let credentialResponse;

function getLoggedInUser() {
    if (!credentialResponse) {
        return undefined;
    }

    return {
        email: credentialResponse?.email,
        firstName: credentialResponse?.given_name,
        lastName: credentialResponse?.family_name,
    };
}

function getLoggedInState() {
    const isLoggedIn = !!credentialResponse;

    if (!isLoggedIn) {
        return {
            isLoggedIn: false,
        };
    }

    return {
        accessToken: credentialResponse,
        isLoggedIn: true,
    };
}

function logOut() {
    credentialResponse = undefined;

    if (window?.google) {
        window?.google?.accounts?.id?.disableAutoSelect();
    }
}

function logIn(token) {
    try {
        credentialResponse = jwtDecode(token);

        return credentialResponse;
    } catch (ex) {
        throw new GoogleUnableToAuthenticateUserError();
    }
}

const googleService = {
    getLoggedInState,
    getLoggedInUser,
    logIn,
    logOut,
};

export default googleService;
